mutation AttachStreamEntrypoint($id: ID!, $contentId: ID) {
  attachStreamEntrypoint(id: $id, contentId: $contentId) {
    id
    stream {
      id
      title
    }
  }
}
